import Layout from '@/components/Layout';
import HeroImageLg from '@/public/assets/Chillar_Hero.png';
import HeroImageSm from '@/public/assets/Chillar_Hero.png';
import SwitchToProductionMode from '@/components/SwitchToProdMode';
import classes from './styles.module.scss';
import {
  Box,
  Image,
  Heading,
  Flex,
  Text,
} from '@chakra-ui/react';
import CTA from '@/components/UI/CTA';
import FAQ from '@/components/faq';
import FAQLanguageTitle from '@/components/FAQLanguageTitle';
import { SIKKA_FAQS } from '@/data/faq';
import { useState } from 'react';

export default function HomePage() {
  const [currentLang, setCurrentLang] = useState('en');

  return (
    <Layout>
      <Flex
        flexDir={['column', 'column', 'row']}
        justifyContent={'center'}
        alignItems={'center'}
        pr={[2, 0]}
      >
        <Box pr={6} w={['100%']} display={['block', null, 'none']}>
          <Image
            src={HeroImageSm.src}
            alt="Chillar illustration"
            mt={[4, null, 'unset']}
            height={['45vh', '45vh', null, '50vh']}
            mx={'auto'}
          />
        </Box>

        <Flex
          flexDir={'column'}
          maxW={['100%']}
          pr={[0, 0, 0, 0, 8]}
          textAlign={['left']}
          mt={['20px', '50px']}
        >
          <Heading
            fontSize={['32px', '36px', '44px', '46px', '52px']}
            mb={['10px', '20px']}
          >
            Easiest Way to{' '}
            <Text fontSize={['32px', '36px', '44px', '46px', '52px']}>
              <span className={classes.textBg}>
                <span className={classes.textFg}>earn unlimited money</span>
              </span>
            </Text>{' '}
            with India's best Earning App
          </Heading>
          <Text
            fontSize={['16px', '16px', '18px', '20px']}
            fontWeight={['400']}
            lineHeight={[6, null, 8]}
            mb={'30px'}
            opacity={0.6}
            color={'#883C1E'}
          >
            Chillar allows you to earn unlimited money by completing simple and
            easy tasks. Upon Completing a set of simple tasks, you will be
            rewarded.
          </Text>
          <Flex justifyContent={['center', 'flex-start']} px={[4, 0]}>
            <CTA />
          </Flex>
        </Flex>

        <Box display={['none', null, 'block']}>
          <Image
            src={HeroImageLg.src}
            alt="Chillar illustration"
            width={['30vw']}
            maxWidth={['550px']}
          />
        </Box>
      </Flex>
      <Flex
        direction={'column'}
        gap={6}
        alignItems={['flex-start', null, 'center']}
        mt={['3rem']}
      >
        <FAQLanguageTitle lang={currentLang} fontSize={'1.5rem'} />
        <FAQ list={SIKKA_FAQS} onLangChange={setCurrentLang} />
      </Flex>
      <SwitchToProductionMode />
    </Layout>
  );
}
